export default __webpack_public_path__ + "static/media/3.838256d2.png";